module.exports = __webpack_public_path__ + "assets/user-white.0fe5232a.svg";